"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DisplayCardIcon = exports.AppItem = void 0;
var React = __importStar(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var globalVars_module_scss_1 = __importDefault(require("../../globalVars.module.scss"));
var DisplayCardShared_1 = require("./DisplayCardShared");
var Container = styled_components_1.default.div.attrs({
    className: 'tws-displaycard',
})(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\t", "\n\theight: 180px;\n\t", "\n\tcursor: ", ";\n\t&:hover {\n\t\t", ";\n\t}\n\tspan,\n\tdiv {\n\t\t", ";\n\t}\n"], ["\n\t", "\n\theight: 180px;\n\t", "\n\tcursor: ", ";\n\t&:hover {\n\t\t", ";\n\t}\n\tspan,\n\tdiv {\n\t\t", ";\n\t}\n"])), function (props) {
    return props.disabled
        ? "background-color: ".concat(globalVars_module_scss_1.default.gray9, ";")
        : props.selected
            ? DisplayCardShared_1.SelectedColor
            : "background-color: ".concat(globalVars_module_scss_1.default.secondaryBlue, ";");
}, DisplayCardShared_1.DisplayCardStyle, function (props) { return (props.disabled ? 'default' : 'pointer'); }, function (props) { return (props.disabled ? '' : DisplayCardShared_1.SelectedColor); }, function (props) { return (props.disabled ? "color: ".concat(globalVars_module_scss_1.default.gray13, " !important") : ''); });
Container.displayName = 'Container';
var HeadContainer = styled_components_1.default.div.attrs({
    className: 'tws-displaycard-headcontainer',
})(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n\theight: 180px;\n\t", "\n\t&::before {\n\t\tborder-color: transparent ", " transparent transparent;\n\t}\n"], ["\n\theight: 180px;\n\t", "\n\t&::before {\n\t\tborder-color: transparent ", " transparent transparent;\n\t}\n"])), DisplayCardShared_1.DisplayCardHeadContainerStyle, function (props) { return (props.disabled ? globalVars_module_scss_1.default.gray7 : globalVars_module_scss_1.default.mainBlue); });
HeadContainer.displayName = 'HeadContainer';
var Headline = styled_components_1.default.span.attrs({
    className: 'tws-displaycard-headline',
})(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n\tfont-size: ", ";\n\tfont-weight: 600;\n\tcolor: #444444;\n\tline-height: 1.2em;\n\tdisplay: block;\n\twidth: ", ";\n\ttext-align: center;\n\tmax-width: 200px;\n"], ["\n\tfont-size: ", ";\n\tfont-weight: 600;\n\tcolor: #444444;\n\tline-height: 1.2em;\n\tdisplay: block;\n\twidth: ", ";\n\ttext-align: center;\n\tmax-width: 200px;\n"])), function (props) { return (props.headlineSize === 'sm' ? '17px' : '32px'); }, globalVars_module_scss_1.default.fullWidth);
Headline.displayName = 'Headline';
exports.AppItem = styled_components_1.default.a.attrs({
    className: 'tws-app-item',
})(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n\tpadding: 20px;\n\tdisplay: flex;\n\tflex-direction: column;\n\tjustify-content: center;\n\talign-items: center;\n\timg {\n\t\theight: 60px;\n\t\twidth: auto;\n\t\tmargin-bottom: 20px;\n\t}\n\tdiv {\n\t\tcolor: ", ";\n\t\tfont-size: 10px;\n\t\tfont-weight: 500;\n\t\tline-height: 14px;\n\t\twhite-space: nowrap;\n\t}\n"], ["\n\tpadding: 20px;\n\tdisplay: flex;\n\tflex-direction: column;\n\tjustify-content: center;\n\talign-items: center;\n\timg {\n\t\theight: 60px;\n\t\twidth: auto;\n\t\tmargin-bottom: 20px;\n\t}\n\tdiv {\n\t\tcolor: ", ";\n\t\tfont-size: 10px;\n\t\tfont-weight: 500;\n\t\tline-height: 14px;\n\t\twhite-space: nowrap;\n\t}\n"])), globalVars_module_scss_1.default.secondaryGray1);
exports.AppItem.displayName = 'AppItem';
var DisplayCardIcon = /** @class */ (function (_super) {
    __extends(DisplayCardIcon, _super);
    function DisplayCardIcon(props) {
        var _this = _super.call(this, props) || this;
        _this.selectDisplayCard = _this.selectDisplayCard.bind(_this);
        _this.state = { isHoverOver: false };
        return _this;
    }
    DisplayCardIcon.prototype.render = function () {
        var _this = this;
        return (React.createElement(Container, { disabled: this.props.disabled, selected: this.props.selected, onClick: this.selectDisplayCard, onMouseOver: function () {
                _this.setState({ isHoverOver: true });
            }, onMouseLeave: function () {
                _this.setState({ isHoverOver: false });
            } },
            React.createElement(HeadContainer, { disabled: this.props.disabled },
                React.createElement(exports.AppItem, { key: this.props.key, href: this.props.href },
                    this.state.isHoverOver && this.props.iconHover && React.createElement("img", { src: this.props.iconHover }),
                    (!this.state.isHoverOver || !this.props.iconHover) && this.props.icon && React.createElement("img", { src: this.props.icon }),
                    React.createElement(Headline, { headlineSize: this.props.textSize }, this.props.text)))));
    };
    DisplayCardIcon.prototype.selectDisplayCard = function (event) {
        var _a = this.props, disabled = _a.disabled, onClick = _a.onClick;
        if (!disabled && onClick) {
            onClick(event);
        }
    };
    DisplayCardIcon.defaultProps = {
        selected: false,
    };
    return DisplayCardIcon;
}(React.Component));
exports.DisplayCardIcon = DisplayCardIcon;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
